import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaTruckLoading, FaPeopleCarry, FaBuilding, FaCheckCircle, FaPhone } from 'react-icons/fa'; // Ícones para Serviço de Transporte
import { LuPiano } from "react-icons/lu";
import SeoHead from "../../components/Menu/components/SeoHead";
import '../../assets/css/servicotransporte.css'; // CSS específico para esta página

const ServicoTransporte = () => {
 
const galleryImages = [
  { 
    id: 1, 
    src: '/img/transporte/1.jpg', 
    alt: 'Cuidado e segurança no transporte de pianos, garantindo que cada instrumento chegue intacto ao seu destino.' 
  },
  { 
    id: 2, 
    src: '/img/transporte/2.jpg', 
    alt: 'Equipe especializada e equipamentos adequados para o transporte seguro de pianos.' 
  },
  { 
    id: 3, 
    src: '/img/transporte/3.jpg', 
    alt: 'Transporte eficiente e confiável, pensado para preservar a integridade e a história do seu piano.' 
  },
];

const transporteSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Waldir Pianos",
  "image": "https://pianoswaldir.com.br/images/logo.jpg",
  "description": "Serviço de transporte especializado para pianos, com equipe experiente, equipamentos adequados, montagem/desmontagem para passagens estreitas, subidas/descidas de escadas e içamentos.",
  "serviceType": "Transporte de Pianos",
  "areaServed": {
    "@type": "AdministrativeArea",
    "name": "São Paulo"
  },
  "url": "https://pianoswaldir.com.br/transporte",
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+55-11-2256-5987", 
    "contactType": "customer service"
  }
};




  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  // Auto-rotatividade das imagens
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHovered) {
        setCurrentImageIndex((prevIndex) => 
          (prevIndex + 1) % galleryImages.length
        );
      }
    }, 5000); // Muda a cada 5 segundos
    
    return () => clearInterval(interval);
  }, [isHovered]);

  const currentImage = galleryImages[currentImageIndex];
  return (
    <div className="servico-transporte-container">
      <SeoHead
  title="Serviço de Transporte de Pianos Especializado | Waldir Pianos"
  description="Transporte seguro e profissional para seu piano. Equipe especializada, técnicas avançadas e equipamentos para qualquer situação, incluindo içamentos e escadas."
  keywords="transporte piano, mudar piano, carreto piano, içamento piano, transporte de pianos, Waldir Pianos"
  image="/img/transporte/1.jpg" 
  url="https://pianoswaldir.com.br/transporte"
  canonicalUrl="https://pianoswaldir.com.br/transporte"
  schemaMarkup={transporteSchema}
/>
      {/* Cabeçalho */}
      <motion.header
        className="servico-transporte-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="servico-transporte-header-content">
          <motion.h1
            className="servico-transporte-main-title"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <FaTruckLoading className="servico-transporte-title-icon" />
            Serviço de Transporte
            <span className="servico-transporte-title-decoration"></span>
          </motion.h1>

          <motion.p
            className="servico-transporte-header-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Seu piano em boas mãos, do início ao fim
          </motion.p>
        </div>
      </motion.header>

      {/* Conteúdo Principal */}
      <div className="servico-transporte-main-content">
        {/* Seção de Texto */}
        <motion.section
          className="servico-transporte-text-section"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
        >
          <motion.div
            className="servico-transporte-text-content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          >
            <h2 className="servico-transporte-section-title">
              <FaPeopleCarry className="servico-transporte-section-icon" />
              Transporte Especializado
            </h2>

            <p className="servico-transporte-classic-text">
              "Transporte especializado faz toda diferença. Ao contrário de móveis comuns, o transporte do piano exige técnicas, equipamentos e profissionais experientes na atividade, que conheçam cada parte do instrumento que devem ser protegidas e como as manusear para que não causem prejuízo ao proprietário."
            </p>

            <div className="servico-transporte-modern-text">
              <p>Aqui você encontra:</p>
              <ul>
                <li>Profissionais com vasta experiência e ESPECIALIZADOS apenas em pianos.</li>
                <li>Técnicos para montagem e desmontagem para passagens estreitas como elevadores.</li>
                <li>Profissionais qualificados para subidas e descidas de escadas.</li>
                <li>Içamentos externos.</li>
              </ul>
            </div>

            <div className="servico-transporte-benefits-grid">
              <div className="servico-transporte-benefit-item">
                <FaTruckLoading className="servico-transporte-benefit-icon" />
                <span>Equipe especializada no transporte de pianos</span>
              </div>
              <div className="servico-transporte-benefit-item">
                <FaBuilding className="servico-transporte-benefit-icon" />
                <span>Soluções para locais de difícil acesso</span>
              </div>
              <div className="servico-transporte-benefit-item">
                <FaCheckCircle className="servico-transporte-benefit-icon" />
                <span>Segurança e cuidado em cada etapa</span>
              </div>
            </div>
          </motion.div>
        </motion.section>

<motion.section
        className="armazenagem-gallery-section"
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.7 }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <h3 className="armazenagem-gallery-title">Serviço de Transporte</h3>
        
        <motion.div 
          className="armazenagem-gallery-container"
          key={currentImageIndex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <div className="armazenagem-piano-image">
            <img 
              src={currentImage.src} 
              alt={currentImage.alt}
              className="armazenagem-gallery-image"
            />
            <div className="armazenagem-image-overlay">
              <span className="armazenagem-piano-description">
                {currentImage.alt}
              </span>
            </div>
          </div>
        </motion.div>
        
        {/* Pontos de navegação */}
        <div className="armazenagem-gallery-dots">
          {galleryImages.map((_, index) => (
            <button
              key={index}
              className={`armazenagem-dot ${index === currentImageIndex ? 'armazenagem-dot-active' : ''}`}
              onClick={() => setCurrentImageIndex(index)}
            />
          ))}
        </div>
      </motion.section>
      </div>

      {/* Rodapé */}
      <motion.footer
        className="servico-transporte-footer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
      >
        <p className="servico-transporte-footer-text">Precisa transportar seu piano com segurança?</p>
        <motion.a
          href="tel:1122565987"
          className="servico-transporte-contact-button"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaPhone /> Fale Conosco
        </motion.a>
      </motion.footer>
    </div>
  );
};

export default ServicoTransporte;